import * as QueryString from 'query-string'
import * as Redux from 'redux'
import * as router from 'universal-router'
import * as RootReducer from '../rootReducer'
import * as Constants from './constants'

export interface RasaRouterContext extends router.Context {
  search: string
  pathname: string
  baseUrl: string
  store: Redux.Store<RootReducer.ApplicationState>
  route: { action: any }
}
export const onEnter = (routerContext: RasaRouterContext, params: router.Params) => {
  if (routerContext.path) {
    const urlParams = QueryString.parse(routerContext.search)
    if (routerContext.baseUrl + routerContext.path === routerContext.pathname) {
      routerContext.store.dispatch({type: Constants.ON_ENTER, routerContext, params, urlParams})
    }
    return routerContext.route.action({...routerContext, params, urlParams})
  }
}



// WEBPACK FOOTER //
// ./src/router/middleware.ts